import { render, staticRenderFns } from "./myworkdetail.vue?vue&type=template&id=5d9abb3d"
import script from "./myworkdetail.vue?vue&type=script&lang=js"
export * from "./myworkdetail.vue?vue&type=script&lang=js"
import style0 from "./myworkdetail.vue?vue&type=style&index=0&id=5d9abb3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports